export * from './static-chat-input'
